import React from 'react';
import { Typography } from '@beeline.com/bp-design-system';
import styled from 'styled-components';
import { LoadingContent } from 'common/LoadingContent';
export const DrawerTitle: React.FC<
  React.PropsWithChildren<{
    loading?: boolean;
    children: React.ReactNode;
    dataTest?: string;
  }>
> = ({ children, loading, dataTest }) => (
  <StyledTitle variant="h2" dataTest={dataTest}>
    <LoadingContent loading={loading}>{children}</LoadingContent>
  </StyledTitle>
);
const StyledTitle = styled(Typography)`
  && {
    margin-bottom: ${({ theme }) => theme.spacingSize.xxl};
  }
`;
